import React from 'react';

const RenewIcon = (): React.ReactElement => (
    <svg
        className="device-svg-icons"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
    >
        <path d="M25.5 18C25.5 17.1716 24.8284 16.5 24 16.5C23.1716 16.5 22.5 17.1716 22.5 18V30C22.5 30.8284 23.1716 31.5 24 31.5C24.8284 31.5 25.5 30.8284 25.5 30V18Z" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 1.5C15.3579 1.5 12 4.85786 12 9V39C12 43.1421 15.3579 46.5 19.5 46.5H28.5C32.6421 46.5 36 43.1421 36 39V9C36 4.85786 32.6421 1.5 28.5 1.5H19.5ZM15 9C15 6.51472 17.0147 4.5 19.5 4.5H28.5C30.9853 4.5 33 6.51472 33 9V39C33 41.4853 30.9853 43.5 28.5 43.5H19.5C17.0147 43.5 15 41.4853 15 39V9Z"
        />
    </svg>
);

export default RenewIcon;
